export const onePageCount = 15;

export const presentQuarter = Math.ceil((new Date().getMonth() + 1) / 4);

// 各公司的巡检批次已统一，批次下拉只需要取任一公司的批次元数据；固定使用公司 13，实际公司筛选仍使用表单 companyId。
export const DEFAULT_BATCH_QUERY_COMPANY_ID = 13;

export const auditStatus = new Map([
  // 全部只在前端定义，查询时删除
  ['ALL', '全部'],
  ['NOT_STARTED', '未开始'],
  ['IN_INSPECTION', '巡检中 '],
  ['WAIT_AUDIT', '未审核'],
  ['AUDIT_FAILED', '审核未通过'],
  ['REINSPECTION_WAIT_AUDIT', '重新巡检未审核'],
  ['RE_INSPECTION', '重新巡检中'],
  ['FINISHED', '已完成'],
  ['BLOCKED', '巡检受阻'],
  ['FIRST_REVIEW_PASSED', '初审完成'],
]);


export const auditStatusList = [...auditStatus.entries()].map(
  ([key, value], index) => ({
    key,
    id: index - 1,
    name: value,
  })
);

export const locationStatus = new Map([
  // 全部只在前端定义，查询时删除
  ['ALL', '全部'],
  ['NO_RECORD', '无定位数据'],
  ['NORMAL', '正常 '],
  ['REVIEW_REQUIRED', '需要稽查'],
  ['REVIEW_FAILED', '稽查未通过'],
  ['REVIEW_PASSED', '稽查通过已纠正经纬度'],
]);

export const locationStatusList = [
  {
    key: 'ALL',
    id: -2,
    name: '全部',
  },
  {
    key: 'NO_RECORD',
    id: 0,
    name: '无定位数据',
  },
  {
    key: 'NORMAL',
    id: 1,
    name: '正常',
  },
  {
    key: 'REVIEW_REQUIRED',
    id: 2,
    name: '需要稽查',
  },
  {
    key: 'REVIEW_FAILED',
    id: 3,
    name: '稽查未通过',
  },
  {
    key: 'REVIEW_PASSED',
    id: 4,
    name: '稽查通过已纠正经纬度',
  },
];


// [...locationStatus.entries()].map(
//   ([key, value], index) => ({
//     key,
//     id: index - 1,
//     name: value,
//   })
// );

/**
 * 巡检状态枚举值（用于 API 查询参数）
 * ALL: -1 全部
 * NOT_STARTED: 0 未开始
 * IN_INSPECTION: 1 巡检中
 * WAIT_AUDIT: 2 未审核
 * AUDIT_FAILED: 3 审核未通过
 * REINSPECTION_WAIT_AUDIT: 4 重新巡检未审核
 * RE_INSPECTION: 5 重新巡检中
 * FINISHED: 6 已完成
 * BLOCKED: 7 巡检受阻
 * FIRST_REVIEW_PASSED: 8 初审完成（等待二次审核）
 */
export const auditStatusEnum = {
  ALL: -1,
  NOT_STARTED: 0,
  IN_INSPECTION: 1,
  WAIT_AUDIT: 2,
  AUDIT_FAILED: 3,
  REINSPECTION_WAIT_AUDIT: 4,
  RE_INSPECTION: 5,
  FINISHED: 6,
  BLOCKED: 7,
  FIRST_REVIEW_PASSED: 8,
};


const firstPathRight = {
  'audit': [
    'INSPECTION_REVIEW_ALL_COMPANY',
    'INSPECTION_REVIEW_OWN_COMPANY',
    'INSPECTION_REVIEW_CUSTOM_COMPANY',
  ],
  // 室分巡检一级审核权限
  'audit-shifen': [
    'INSPECTION_REVIEW_ALL_COMPANY_SHIFEN',
    'INSPECTION_REVIEW_OWN_COMPANY_SHIFEN',
    'INSPECTION_REVIEW_CUSTOM_COMPANY_SHIFEN',
  ],
  'batch-management': [
    'BATCH_MANAGEMENT',
  ],
  'external-group-management': [
    'DB_USER_ADD',
  ],
  'record': ['INSPECTION_REVIEW_LOCATION'],
  'user-manager': ['DB_USER_ADD'],
  'all': ['ALL'],
  'summary': ['ALL'],
  'due-diligence': ['ALL'],
  'inspection-attachment': ['ALL'],
};

export const viewRight = {
  ...firstPathRight,
  'all-audit': firstPathRight.audit,
  'to-audit': firstPathRight.audit,
  // 待审核-室分 需要室分一级审核权限
  'to-audit-shifen': firstPathRight['audit-shifen'],
  // 二次审核-室分 需要室分二级审核权限
  'second-review-shifen': ['INSPECTION_SECOND_REVIEW_SHIFEN'],
  'project-detail': firstPathRight.audit,
  'station': firstPathRight.audit,
  'batch': firstPathRight.audit,
  'user-manager': firstPathRight['user-manager'],
  'company-summary': ['COMPANY_SUMMARY'],
  'department-summary': ['ALL'],
  'due-diligence': firstPathRight['due-diligence'],
  'all-due-diligence': ['GB_PROJECT_ALL_COMPANY', 'GB_PROJECT_OWN_COMPANY', 'GB_PROJECT_CUSTOM_COMPANY', 'GB_PROJECT_CREATE_ALL_COMPANY', 'GB_PROJECT_CREATE_OWN_COMPANY', 'GB_PROJECT_CREATE_CUSTOM_COMPANY'],
  'pending-review': ['GB_PROJECT_ALL_COMPANY', 'GB_PROJECT_OWN_COMPANY', 'GB_PROJECT_CUSTOM_COMPANY', 'GB_PROJECT_CREATE_ALL_COMPANY', 'GB_PROJECT_CREATE_OWN_COMPANY', 'GB_PROJECT_CREATE_CUSTOM_COMPANY'],
  'second-review': ['GB_PROJECT_SECOND_REVIEW'],
  'pending-upload': ['ALL'],
  'project-summary': ['ALL'],
  'station-details': ['ALL'],

  'project-list': firstPathRight['due-diligence'],
  'batch-management': firstPathRight['batch-management'],
  'external-group-management': firstPathRight['external-group-management'],
  'inspection-attachment': firstPathRight['inspection-attachment'],
};

export const presentYear = new Date().getFullYear();
export const yearsList = [...Array(presentYear - 2016).keys()]
  .reverse()
  .map((num) => presentYear - num);

export const mapPointerMark = [
  require('leo-assets/position-marks/0.svg'),
  require('leo-assets/position-marks/1.svg'),
  require('leo-assets/position-marks/2.svg'),
  require('leo-assets/position-marks/3.svg'),
  require('leo-assets/position-marks/4.svg'),
  require('leo-assets/position-marks/5.svg'),
  require('leo-assets/position-marks/6.svg'),
  require('leo-assets/position-marks/7.svg'),
  require('leo-assets/position-marks/8.svg'),
  require('leo-assets/position-marks/9.svg'),
  require('leo-assets/position-marks/10.svg'),
  require('leo-assets/position-marks/11.svg'),
  require('leo-assets/position-marks/12.svg'),
  require('leo-assets/position-marks/13.svg'),
  require('leo-assets/position-marks/14.svg'),
  require('leo-assets/position-marks/15.svg'),
  require('leo-assets/position-marks/16.svg'),
  require('leo-assets/position-marks/17.svg'),
  require('leo-assets/position-marks/18.svg'),
  require('leo-assets/position-marks/19.svg'),
  require('leo-assets/position-marks/20.svg'),
];
